// (function($, ns, win, doc, undefined)
// {
	/* social media library */
var cnnshare = {

	/* store load configuration for each social site's api */
	'apiconfig' : [],


	/* set analtyics engine for social tracking */
	'analytics' : 'o',


	/* set analytics for tracking, o for omniture and b for bango */
	'setanalytics' : function(a_id) {

		cnnshare.analytics = a_id;

	},


	/* adds tracking param to manual links */
	'addurlparam' : function(url, param, value) {

		var qstring = /\?.+$/;
		if (qstring.test(url)){
			return url + '&' + param + '=' + value;
		}
		else {
			return url + '?' + param + '=' + value;
		}

	},


	/* supported social site configurations */
	'sites' : {

		'email' : {
			'buildurl' : function(t_obj) {
				return 'mailto:?to=&subject=On%20CNN:%20'+encodeURIComponent(t_obj.title)+'&body='+encodeURIComponent(t_obj.title)+'%0D%0A%0D%0A'+encodeURIComponent(cnnshare.addurlparam(t_obj.url, 'sr', 'sharebar_email'))
			},
			'popwidth' : 150, 'popheight' : 150, 'popscroll' : 'no'

		},

		'facebook' : {
			'buildurl' : function(t_obj) {
				return 'https://www.facebook.com/share.php?u=' + encodeURIComponent(cnnshare.addurlparam(t_obj.url, 'sr', 'sharebar_facebook')) + '&title=' + encodeURIComponent(t_obj.title);
			},
			'popwidth' : 550, 'popheight' : 420, 'popscroll' : 'no',
			'loadapi' : function(cb) {

				/* call to load api */
				(function(d, debug){
					var js, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
					if (d.getElementById(id)) {return;}
					js = d.createElement('script'); js.id = id; js.async = true;
					js.src = "//connect.facebook.net/en_US/all" + (debug ? "/debug" : "") + ".js";
					ref.parentNode.insertBefore(js, ref);
				}(document, /*debug*/ false));

				window.fbAsyncInit = function() {

					FB.init({
						appId      : '80401312489', /* App ID */
						status     : true, /* check login status */
						cookie     : true, /* enable cookies to allow the server to access the session */
						xfbml      : true,  /* parse XFBML */
						oauth      : true
					});

					FB.Event.subscribe('edge.create', function(targetUrl) {
						window.cnnshare.share.track({ 'type' : 'click', 'site' : 'facebook' });
					});

					if (typeof cb === 'function') { cb.apply(); }

				};

			}
		},

		'twitter' : {
			'buildurl' : function(t_obj) {
				return 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(cnnshare.addurlparam(t_obj.url, 'sr', 'sharebar_twitter')) + '&text=' + encodeURIComponent(t_obj.tweet);
			},
			'popwidth' : 550, 'popheight' : 460, 'popscroll' : 'no',
			'loadapi' : function(cb) {

				/* call to load api */
				window.twttr = (function (d,s,id) {

					var t, js, fjs = d.getElementsByTagName(s)[0];
					if (d.getElementById(id)) return; js=d.createElement(s); js.id=id;
					js.src="//platform.twitter.com/widgets.js"; fjs.parentNode.insertBefore(js, fjs);
					return window.twttr || (t = { _e: [], ready: function(f){ t._e.push(f) } });

				}(document, "script", "twitter-wjs"));

				window.twttr.ready(function (twttr) {

					twttr.events.bind('click', function(event) {
						window.cnnshare.share.track({ 'type' : 'click', 'site' : 'twitter' });
					});

					if (typeof cb === 'function') { cb.apply(); }

				});


			}
		}


	},


	/* share library will be defined below for cleaner code */
	'share' : {},


	/* specify which apis to load and callbacks to call */
	'setapiconfig' : function(api_arr) {

		cnnshare.apiconfig = api_arr;

	},


	/* initialize cnn social library */
	'init' : function() {

		/* load necessary social apis */
		var t_arr = cnnshare.apiconfig;

		for(var i = 0; i < t_arr.length; i++) {

			var t_api = t_arr[i];
			if(typeof t_api.success === 'function') { cnnshare.sites[t_api.site].loadapi(t_api.success); }
			else { cnnshare.sites[t_api.site].loadapi(); }

		}

		/* setup share instances */
		if(typeof cnnshare.share.data.bars != 'undefined') {
			cnnshare.share.init();
		}

	}


};
/* end cnnshare */



/* share library */
cnnshare.share = {

	/* store each instance */
	'data' : {
		'bars' : {}
	},


	/* add a single sharebar instance to data */
	'addconfig' : function(c_obj) {

		cnnshare.share.data.bars[c_obj.id] = c_obj;

	},


	/* add a multiple config array to data */
	'setconfig' : function(c_arr) {

		/* iterate through and add each one */
		for(var i = 0; i < c_arr.length; i++) {
			cnnshare.share.addconfig(c_arr[i]);
		}

	},


	/* update the url for all share instances - for dynamic video/ajax-y pages */
	'updateurl' : function(t_url) {

		//var t_bar = cnnshare.share.data.bars[t_id]

	},

	'updatesingleurl' : function(t_id, t_url, t_title) {

		var t_bar = cnnshare.share.data.bars[t_id];
		t_bar.url = t_url;
		t_bar.title = t_title;
		cnnshare.share.data.bars[t_id] = t_bar;

	},


	/* custom button click function */
	'click' : function(t_id, t_site) {

		if(window.console) {
			console.log('clicked ' + t_site + ' in: ' + t_id);
		}

		/* trigger share actions */
		var t_bar = cnnshare.share.data.bars[t_id];
		var t_social = cnnshare.sites[t_site];

		cnnshare.share.popup(t_social.buildurl(t_bar), t_site, t_social.popwidth, t_social.popheight, t_social.popscroll);

		/* track click action */
		cnnshare.share.track({ 'type' : 'click', 'site' : t_site });

	},


	/* launch share url in popup window */
	'popup' : function(t_url, t_site, t_width, t_height, t_scroll) {

		return window.open(t_url, 'cnn_pop_' + t_site, 'width=' + t_width + ',height=' + t_height + ',resizable=yes,scrollbars=' + t_scroll);

	},


	/* default tracking callback but we would prefer the setting of a tracking callback in shareconfig */
	'track' : function(t_obj) {

		if(window.console) {
			console.log(t_obj);
		}

		try {

			if(cnnshare.analytics === 'o') {
				if(jsmd) {
					if(t_obj.type === 'click') {
						jsmd.trackMetrics("social-click", { 'clickObj' : { 'socialType' :t_obj.site + '_click' } });
					}
					else if(t_obj.type === 'success')	{
						jsmd.trackMetrics("social-click", { 'clickObj' : { 'socialType' : t_obj.site + '_post' } });
					}
				}
			}
			else if(cnnshare.analytics === 'b') {
				if(typeof(bangoSocial) === 'function') {
					bangoSocial({ 'socialMedia' : t_obj.site });
				}
			}

		}
		catch(e) {

			if(window.console) {
				console.log("error thrown while registering click tracking. Message - " + e.message);
			}

		}

	},


	/* start up the sharing */
	'init' : function() {

		var t_bars = cnnshare.share.data.bars;

		/* interate through each bar instance */
		for (var t_bar in t_bars) {

			var t_obj = t_bars[t_bar];
			var t_cntr = '#' + t_obj.id + ' .c_sharebar_cntr';

			/* remove loading class for container once DOM is ready */
			jQuery(t_cntr).removeClass('c_sharebar_loading');

		}

	}

};
/* end cnnshare.share */

window.cnnshare = cnnshare;

/* configure apis to load and specify their callbacks */
cnnshare.setapiconfig([
	{
		'site' : 'facebook',
		'success' : function() {
			/* trigger connect-cnnsocial.js calls */
			window.cnn_fbAsyncInit();
		}
	},
	{ 'site' : 'twitter' }
]);

/* add the multiple config instance for sharebars */
cnnshare.share.setconfig(cnn_shareconfig);

function shareClick () {
	cnnshare.share.click('cnn_sharebar1',this.dataset.service);
	console.log(this.dataset.service);
}

const shareButtons = document.querySelectorAll('.share-button');

shareButtons.forEach(shareButton => shareButton.addEventListener('click', shareClick));


// WEBPACK FOOTER //
// ./src/js/_sharebar.js